import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateTbo} from "../../types/api/guide/tbo.types";

export const tboService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.tbo.getAll),

    create: (tbo: CreateTbo) =>
        apiCall.post(apiUrls.guide.tbo.create, tbo),
}